import { useTranslation } from 'react-i18next';

import { AppRoute } from '../models/routeProps';
import { CookiesNoticePage } from '../pages/CookieNoticePage';
import { LandingPage } from '../pages/LandingPage';
import { PrivacyPolicyPage } from '../pages/PrivacyPolicyPage';
import { TermsAndConditionsPage } from '../pages/TermsAndConditionsPage';

export const PageRoutes = (): AppRoute[] => {
  const { t } = useTranslation();
  return [
    {
      component: LandingPage,
      path: '/',
      title: t('landingPage.title')
    },
    {
      component: CookiesNoticePage,
      path: '/cookies',
      title: t('cookiesNoticePage.title')
    },
    {
      component: PrivacyPolicyPage,
      path: '/privacy',
      title: t('privacyPolicyPage.title')
    },
    {
      component: TermsAndConditionsPage,
      path: '/terms',
      title: t('termsAndConditionsPage.title')
    }
  ];
};
